import { PbxHttpClient } from "@/services/httpclient";

const state = {
  allTypifications: [],
};

const getters = {};

const mutations = {
  SET_ALL_TYPIFICATIONS(state, payload) {
    state.allTypifications = payload;
  },

  PUSH_TYPIFICATIONS: (state, payload) => {
    const value = state.allTypifications.find((element) => {
      return element.id === payload.id;
    });
    if (value === undefined) {
      state.allTypifications.push(payload);
    }
  },

  UPDATE_TYPIFICATIONS: (state, payload) => {
    const indexupdate = state.allTypifications
      .map((element) => {
        return element.id;
      })
      .indexOf(payload.id);
    if (indexupdate > -1) {
      state.allTypifications.splice(indexupdate, 1, payload);
    }
  },

  DELETE_TYPIFICATIONS: (state, payload) => {
    const indexdelete = state.allTypifications
      .map((element) => {
        return element.id;
      })
      .indexOf(payload);
    if (indexdelete > -1) {
      state.allTypifications.splice(indexdelete, 1);
    }
  },
};

const actions = {
  async REGISTER_TYPIFICATIONS({ commit }, payload) {
    try {
      const response = await PbxHttpClient.post("/clients/typification", payload);
      console.log("RESPONSE", response)
      commit("queue/UPDATE_QUEUE", response.data.cola, { root: true });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SHOW_TYPIFICATIONS({ commit }) {
    try {
      const response = await PbxHttpClient.get("/clients/typification");
      commit("SET_ALL_TYPIFICATIONS", response.data.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async EDIT_TYPIFICATIONS({ commit }, payload) {
    try {
      const response = await PbxHttpClient.put(`/clients/typification/`, payload);
      commit("queue/UPDATE_QUEUE", response.data.cola, { root: true });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async DELETE_TYPIFICATIONS({ commit }, payload) {
    // console.log(payload)
    try {
      const response = await PbxHttpClient.post(`/clients/typification/destroy`, payload);
      if (response.data.cola)
        commit("queue/UPDATE_QUEUE", response.data.cola, { root: true });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

// Exportar Clientes
export const typifications = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
